import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import styles from "./SecurityTeamList.module.css";
import classNames from "classnames";
import { v4 } from "uuid";

import SecurityTeamItem from "../SecurityTeamItem";
import TableSortItem from "shared/TableSortItem";
import { Select } from "shared/Select/Select";
import { ReactComponent as PinIcon } from "../../assets/open-pin.svg";

/**
 * Interactive component.
 * Displays the security team or event staff list in the staff section of event details.
 */
export function SecurityTeamList({ securityTeamList, onPin, header }) {
  const [sortedList, setSortedList] = useState(
    securityTeamList.sort((a, b) => b.pinned - a.pinned)
  );

  // Handles sort function for CCW.
  const [sortOrder, setSortOrder] = useState("desc");
  const handleSort = (_sortOrder) => {
    // Puts pinned teams on top regardless of CCW status.
    let pins = [];
    let nonPins = [];

    securityTeamList.map((team) =>
      team.pinned ? pins.push(team) : nonPins.push(team)
    );

    [pins, nonPins].forEach((list) => {
      list.sort((a, b) => b.CCW - a.CCW);
      if (_sortOrder === "asc") list.reverse();
    });

    setSortedList([...pins, ...nonPins]);
  };

  // Updates sortedList on re-render (pin change).
  useMemo(() => handleSort(sortOrder), [securityTeamList]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>{header}</p>
        <div className={styles["select-container"]}>
          <Select
            // options={["Upload", "Edit", "Add", "Create Chat"]}
            options={["Upload", "Edit", "Add"]}
            placeholder="Select"
            onChange={(value) => alert(value)}
          />
        </div>
      </div>
      <div className={styles.flex}>
        <div
          className={classNames(styles["flex-header"], {
            [styles.flip]: sortOrder !== "asc",
          })}
        >
          <div className={styles["pin-container"]}>
            <PinIcon />
          </div>
          <p>Name</p>
          <p>Phone</p>
          <p>Email</p>
          <TableSortItem
            value={sortOrder}
            title="CCW"
            onChange={() => {
              const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
              handleSort(newSortOrder);
              setSortOrder(newSortOrder);
            }}
          />
        </div>
        <div className={classNames(styles.flex, styles.list)}>
          {sortedList.map((team) => (
            <SecurityTeamItem
              key={v4()}
              item={team}
              onPin={(newPin) => onPin(newPin, team)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

SecurityTeamList.propTypes = {
  /**
   * Array of security team items.
   */
  securityTeamList: PropTypes.arrayOf(
    PropTypes.shape({
      pinned: PropTypes.bool,
      name: PropTypes.string,
      phoneNumber: PropTypes.string,
      email: PropTypes.string,
      CCW: PropTypes.bool,
    })
  ),
  /**
   * Function that fires when the pin is clicked.
   */
  onPin: PropTypes.func,
  /**
   * Title of the list.
   */
  header: PropTypes.string,
};

SecurityTeamList.defaultProps = {
  securityTeamList: [],
};
